import { DE_GAME } from './game.js';
import { DE_MAIN_A } from './main-a.js';
import { DE_MAIN_B } from './main-b.js';
import { DE_MENU } from './menu.js';
import { DE_OVERRIDES } from './overrides.js';
import { DE_PERFORMANCE } from './performance.js';
import { DE_SHARED } from './shared.js';
import { DE_UI } from './ui.js';

/**
 * German dictionary, keyed by the exact English source text passed to t().
 * Split per UI area so the files stay reviewable; later entries win.
 */
export const DE: Readonly<Record<string, string>> = Object.freeze({
  ...DE_SHARED,
  ...DE_GAME,
  ...DE_UI,
  ...DE_MENU,
  ...DE_MAIN_A,
  ...DE_MAIN_B,
  ...DE_PERFORMANCE,
  ...DE_OVERRIDES,
});
